import { RANDOM_STRING } from '../ramdomKey';
import { generateEleveUserName, generateMailIfNone } from './userCreateHelpers';
import { ID } from '../../types/typeDef';
import {
  AddEleveTypes,
  CSVEleveTypes,
  EleveInputTypes
} from '../../types/user/eleve.def';
import { capitalizeField, upperCaseField } from '../forms/prettifyField';
import { ELEVE_ID } from './authorization';

export const addEleveParams = (
  data: AddEleveTypes,
  maClasse: ID
): EleveInputTypes => {
  const userName = generateEleveUserName(data.firstname);
  return {
    ...data,
    username: userName,
    email: generateMailIfNone(data.email, userName),
    password: RANDOM_STRING(),
    classes: maClasse,
    confirmed: true,
    role: ELEVE_ID
  };
};

export const eleveFormCSVParams = (eleve: CSVEleveTypes, maClasse) =>
  addEleveParams(
    {
      lastname: upperCaseField(eleve.Nom),
      firstname: capitalizeField(eleve.Prenom)
    },
    maClasse
  );
